// Module-level constant — shared by SignIn (/auth) and SignUp (/auth/sign-up).
// Keeping a stable reference matters: an inline `appearance={{...}}` prop creates
// a new object on every render; some Clerk widget effects depend on appearance
// identity and re-running them can cause user-visible artefacts (iter_14: two
// OTP codes sent on a single sign-in, presumed re-init on parent re-render).
export const CLERK_APPEARANCE = {
  elements: {
    rootBox: 'w-full',
    card: 'bg-paper border border-hairline rounded-lg shadow-none p-6',
    headerTitle: 'hidden',
    headerSubtitle: 'hidden',
    socialButtonsBlockButton: 'border-hairline hover:bg-stone-50 normal-case',
    socialButtonsBlockButtonText: 'text-sm font-medium',
    dividerLine: 'bg-hairline',
    dividerText: 'text-[10px] tracking-meta uppercase text-ink-3',
    formFieldLabel: 'font-mono text-[11px] tracking-meta uppercase text-ink-2',
    formFieldInput:
      'border-hairline bg-canvas focus:border-ink focus:ring-2 focus:ring-azure/15',
    formButtonPrimary:
      'bg-ink text-ink-inv hover:bg-ink/90 normal-case rounded shadow-none',
    footerActionText: 'text-[13px] text-ink-3',
    footerActionLink: 'text-ink border-b border-current pb-px hover:text-ink',
    identityPreviewText: 'text-sm',
    identityPreviewEditButton: 'text-azure-700',
  },
  variables: {
    colorPrimary: '#1A1814',
    colorText: '#1A1814',
    colorTextSecondary: '#6B6862',
    colorBackground: '#FCFAF6',
    colorInputBackground: '#FCFAF6',
    colorInputText: '#1A1814',
    borderRadius: '6px',
    fontFamily: '"Inter Tight", system-ui, sans-serif',
  },
} as const;
